export enum UnitConversionKey {
  BloodSugar = '1',
  BloodSugarFasting = '1.1',
  BloodSugar2H = '1.2',
  BloodSugarHbA1c = '1.3',
  LiverEnzyme = '2',
  LiverEnzymeSgot = '2.1',
  LiverEnzymeSgpt = '2.2',
  Lipid = '3',
  LipidCholesterol = '3.1',
  LipidLdl = '3.2',
  LipidHdl = '3.3',
  LipidTriglyceride = '3.4',
  UreCreatinine = '4',
  Urea = '4.1',
  Creatinine = '4.2',
  UricAcid = '5.1'
}
